import React from 'react'
import { Link } from 'react-router-dom'
import { Network, Check } from 'lucide-react'
import { CUSTOM_PLAN, customPlanPath, type CustomPlanOrigin } from '../../lib/customPlan'

interface CustomPlanCardProps {
  origem: CustomPlanOrigin
}

/**
 * Card estático "Personalizado" — sem linha em `plans`, sem Stripe, sem
 * reagir ao toggle mensal/anual. Renderiza apenas o conteúdo interno; cada
 * superfície (billing, landing) fornece o próprio wrapper (borda/sombra/animação)
 * para casar visualmente com os cards irmãos.
 */
const CustomPlanCard: React.FC<CustomPlanCardProps> = ({ origem }) => {
  return (
    <div className="p-8">
      <div className="text-center mb-8">
        <div className="w-16 h-16 rounded-caderno-md bg-terra-100 dark:bg-terra-700 flex items-center justify-center mx-auto mb-4">
          <Network className="w-8 h-8 text-terra-700 dark:text-terra-300" aria-hidden="true" />
        </div>

        <p className="font-mono text-caderno-xs uppercase tracking-widest text-ink-400 dark:text-ink-300 mb-2">
          {CUSTOM_PLAN.eyebrow}
        </p>

        <h3 className="text-2xl font-display text-ink-900 dark:text-cream-50 mb-2">
          {CUSTOM_PLAN.name}
        </h3>

        <div className="mb-4">
          <span className="text-3xl font-display font-semibold text-ink-900 dark:text-cream-50">
            {CUSTOM_PLAN.priceLabel}
          </span>
        </div>

        <p className="text-ink-500 dark:text-cream-300">{CUSTOM_PLAN.description}</p>
      </div>

      <ul className="space-y-4 mb-8">
        {CUSTOM_PLAN.features.map((feature) => (
          <li key={feature} className="flex items-start space-x-3">
            <Check className="w-5 h-5 text-moss-500 mt-0.5 flex-shrink-0" aria-hidden="true" />
            <span className="text-ink-700 dark:text-cream-100">{feature}</span>
          </li>
        ))}
      </ul>

      <Link
        to={customPlanPath(origem)}
        className="w-full inline-flex items-center justify-center py-3 px-4 rounded-caderno-sm font-medium border-2 border-ink-900 text-ink-900 hover:bg-ink-900 hover:text-cream-50 dark:border-cream-50 dark:text-cream-50 dark:hover:bg-cream-50 dark:hover:text-ink-900 transition-colors"
      >
        {CUSTOM_PLAN.cta}
      </Link>
    </div>
  )
}

export default CustomPlanCard
